export default "__VITE_ASSET__48e332ce__"